interface ArrowUpProps {
  bold?: boolean
}

export function ArrowUp({ bold = false }: ArrowUpProps): JSX.Element {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="arrowUp">
      <path
        d="M9.15918 5.38684L5.15918 1.27584L1.15918 5.38684"
        className="stroke-svgColor"
        strokeWidth={bold ? '2.5' : '1'}
      />
    </svg>
  )
}
